import * as React from 'react';
import type { SVGProps } from 'react';

const SvgMobileMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M22.5 5.872h-21V7.62h21V5.872ZM22.5 11.122h-21v1.748h21v-1.748ZM22.5 16.372h-21v1.748h21v-1.748Z" />
  </svg>
);

export default SvgMobileMenu;
